import React, { Component } from 'react';
import ReactTable from 'react-table';
import {
  inject,
  observer,
} from 'mobx-react';
import Filters from '../../components/Filters/Filters';
import {
  Col,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import PaginationTable from '../../components/Pagination/PaginationTable';
import { withTranslation } from 'react-i18next';
import getSortHeaderProps from '../../utils/get-sorted-headers';

class ProductTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [{id: 'itemCode', desc: false}],
      filter: '',
    };
  }

  onEdit = id => {
    const { mixStore, onEdit } = this.props;
    mixStore.editExtra(id);
    onEdit();
  };

  getColumns = (editable) => {
    const { mixStore, t } = this.props;
    const { sorted } = this.state;
    const { deleteExtra } = mixStore;

    return [
      {
        headerText: t('Code'),
        accessor: 'itemCode',
        id: 'itemCode',
        maxWidth: 120,
        className: 'sticky',
        headerClassName: 'sticky',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Description'),
        accessor: 'itemDescription',
        id: 'itemDescription',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Unit'),
        accessor: 'unitSymbol',
        id: 'unitSymbol',
        maxWidth: 70,
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Taxable'),
        accessor: d => d.taxable ? t('Yes') : t('No'),
        id: 'taxable',
        maxWidth: 70,
        ...getSortHeaderProps(sorted),
      },
      {
        accessor: 'actions',
        width: 63,
        Cell: row => (
          <div>
            {editable
              ? (
                <div className="text-right">
                  <a className="btn btn-sm btn-default btn-action"
                    title={t('Edit')}
                    onClick={() => this.onEdit(row.original.id)}>
                    <i className="fa fa-pencil"/>
                  </a>
                  <a className="btn btn-sm btn-default btn-action"
                    title={t('Delete')}
                    onClick={() => deleteExtra(row.original.id)}>
                    <i className="fa fa-remove"/>
                  </a>
                </div>
              )
              : (
                <div className="text-right">
                  <a className="btn btn-sm btn-default btn-action"
                    title={t('Edit')}
                    onClick={() => this.onEdit(row.original.itemId)}>
                    <i className="fa fa-pencil"/>
                  </a>
                </div>
              )}
          </div>
        ),
      },
    ];
  };

  handleChange = (e) => {
    const filter = e.target.value;
    this.setState({ filter });
  };

  render() {
    const { mixStore, editable, t } = this.props;
    const data = editable ? mixStore.extra : mixStore.allExtra;
    const { filter } = this.state;

    return (
      <div className={`product-table-wrap data-${data.length}`}>
        <Col sm={4} xs={10} className={'no-padding'}>
          <FormGroup>
            <FormControl
              type="text"
              value={filter}
              placeholder={t('Search')}
              onChange={this.handleChange}
            />
          </FormGroup>
        </Col>
        <Filters filter={filter} data={data} renderData={(items) => (
          <ReactTable
            className="-highlight product-table"
            data={items}
            noDataText={' '}
            columns={this.getColumns(editable)}
            sorted={this.state.sorted}
            onSortedChange={sorted => this.setState({ sorted })}
            showPaginationTop={false}
            showPaginationBottom={true}
            showPageSizeOptions={true}
            PaginationComponent={PaginationTable}
            resizable={false}
            minRows={1}
            defaultPageSize={100}
            getTrProps={(state, rowInfo) => {
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: () => {
                    this.onEdit(editable ? rowInfo.original.id : rowInfo.original.itemId);
                    this.setState({
                      selected: rowInfo.index,
                    });
                  },
                  className: rowInfo.index === this.state.selected ? 'row-selected': '',
                };
              }
              return {};
            }}
          />
        )} />
      </div>
    );
  }
}

export default withTranslation()(inject('mixStore')(observer(ProductTable)));
